import axios from 'axios';
import {getEndPoint} from '../config';
export const storeOnlineStatus = {
  state: {
    reception: [],
    isLoadingComplete: false,
    isLoadingError: false,
    endpoint: '',
  },
  async setReception () {
    const date = new Date();
    this.endpoint = getEndPoint(process.env.NODE_ENV);
    await axios
      .get(this.endpoint.online_status + "?" + date.getTime())
      .then(response => {
        this.state.reception = response.data.reception;
        this.state.isLoadingComplete = true;
        this.state.isLoadingError = false;
      })
      .catch((e) => {
        this.state.isLoadingError = true;
        console.log('error', e);
      });
  },
}
